import React from "react";
import { Link, graphql } from "gatsby";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";

import GatsbyImageWithSVGSupport from "./GatsbyImageWithSVGSupport";
import RichTextBlock from "./RichTextBlock";

import Arrow from "../images/icons/arrow-narrow.svg";

import "../styles/components/AwardCards.scss";

const AwardLink = ({ text, link, className }) => {
    if (link.startsWith("/")) {
        return (
            <Link className="text-white my-2" to={link}>
                {text} <Arrow />
            </Link>
        );
    }

    return (
        <a
            href={link}
            target="_blank"
            rel="noreferrer"
            className="text-white my-2"
        >
            {text} <Arrow />
        </a>
    );
};

AwardLink.propTypes = {
    text: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    className: PropTypes.string,
};

const AwardCards = ({ title, leadText, cards }) => {
    if (!cards?.length) return;

    return (
        <div className="award-cards">
            <h2 className="mb-2">{title}</h2>
            <RichTextBlock content={leadText} />
            <Row className="mt-5">
                {cards.map(award => (
                    <Col key={award.title} xs={12} md={6} className="my-3">
                        <article className="award">
                            <GatsbyImageWithSVGSupport image={award.image} />

                            <div className="award-overlay">
                                <div className="award-links">
                                    <AwardLink
                                        link={award.firstUrl}
                                        text={award.firstUrlText}
                                    />
                                    {award.secondUrl && award.secondUrlText && (
                                        <AwardLink
                                            link={award.secondUrl}
                                            text={award.secondUrlText}
                                        />
                                    )}
                                </div>
                            </div>
                        </article>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

AwardCards.propTypes = {
    title: PropTypes.string.isRequired,
    leadText: PropTypes.shape({ raw: PropTypes.string.isRequired }),
    cards: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            image: PropTypes.shape({
                title: PropTypes.string,
                description: PropTypes.string,
                gatsbyImageData: PropTypes.object,
                file: PropTypes.shape({
                    contentType: PropTypes.string.isRequired,
                    url: PropTypes.string.isRequired,
                }),
            }).isRequired,
            firstUrl: PropTypes.string.isRequired,
            firstUrlText: PropTypes.string.isRequired,
            secondUrl: PropTypes.string,
            secondUrlText: PropTypes.string,
        }),
    ).isRequired,
};

export const query = graphql`
    fragment DynamicAwardCards on ContentfulAwardCards {
        sys {
            contentType {
                sys {
                    id
                }
            }
        }
        title
        leadText {
            raw
        }
        cards {
            title
            firstUrl
            firstUrlText
            secondUrl
            secondUrlText
            image {
                gatsbyImageData(layout: CONSTRAINED)
                title
                description
                file {
                    contentType
                    url
                }
            }
        }
    }
`;

export default AwardCards;
